import React from 'react'


import AuthManager from '../utils/AuthManager'

export default class AddProduct extends React.Component {
  render() {
    if(!AuthManager.currentUser){
      return null
    }
    return (
      <div className="row">
        <div className="col-md-4 mx-auto">
          <div className="alert-addproduct feature feature-3 boxed boxed--lg boxed--border unmarg--bottom">
            <div className="icon-div text-center">
              <span className="position-relative inline-block">
                <i className="icon icon-Danger icon--lg color--white"></i>
              </span>
            </div>
            <h5 className="my-3 text-center color--white">YOU HAVE NOT SET ANY PRODUCTS TO DISPLAY</h5>
            <p className="text-center color--white">
              Use the settings to configure the products you want to display.
            </p>
          </div>
        </div>
        </div>
    )
  }
}
